import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PackageGroupDiscountViewModel } from 'src/app/_models/generatedModels';
import { ConferenceCMSService } from 'src/app/_services/generatedServices';


@Component({
  selector: 'bxl-conference-group-discounts-modal',
  templateUrl: 'conference-group-discounts-modal.component.html',
})

export class ConferenceGroupDiscountsModalComponent implements OnInit {
  initialized = false;
  packages: PackageGroupDiscountViewModel[];

  @Input() conferenceId: number;
  @Input() conferencePurchaseOrderId: number | null;

  constructor(public activeModal: NgbActiveModal, private cmsService: ConferenceCMSService) {}

  ngOnInit(): void {
    this.cmsService.getPackageGroupDiscountsOnly(this.conferenceId, this.conferencePurchaseOrderId || '').subscribe((packages) => {
      this.packages = packages;
      this.initialized = true;
    });
  }
}
